import { effects } from 'redux-saga'
import callWithHmac from '../effects/callWithHmac'

import { receiveClientList } from '../../modules/client'
import { begin, end } from '../../modules/loading'

export default function* loadListSaga(invocation) {
  try {
    yield effects.put.resolve(begin('client-list'))

    const result = yield effects.call(callWithHmac, invocation.getClientList)

    yield effects.put.resolve(receiveClientList(result.clients))
  } finally {
    yield effects.put.resolve(end('client-list'))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/client/loadList.js